<template>
  <div class="app-page files bulma-dropdown">
    <vue-headful title="ALICE | Files"></vue-headful>
    <div class="single-page-full">
      <div class="page-header">
        <h1>Files</h1>
      </div>
    </div>
    <div class="content-wrapper">
      <file-upload @on-reload-knowledge-file-list="handleReloadKnowledgeFileList($event)"/>
      <file-management-table :isReloadKnowledgeFileList="isReloadKnowledgeFileList" @on-reload-knowledge-file-list="handleReloadKnowledgeFileList($event)" class="mt-2"/>
    </div>
  </div>
</template>
<script>
import FileManagementTable from '../../components/Tables/Knowledge/FileManagementTable.vue';
import FileUpload from '../../components/Uploads/Knowledge/FileUpload.vue';

export default {
  name: 'files',
  components: {
    FileManagementTable,
    FileUpload,
  },
  data() {
    return {
      isReloadKnowledgeFileList: false,
    };
  },
  methods: {
    handleReloadKnowledgeFileList(value) {
      this.isReloadKnowledgeFileList = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.files {
  .page-header {
    padding: 10px;
    background-color: #fff;
  }

  .label {
    margin: 0;
    line-height: 1.8rem;
  }

  .content-wrapper {
    padding: 10px;
  }
}
</style>
